import { createStyles } from '@mantine/styles';

export const useStyles = createStyles({});
